import React, { useEffect, useState } from 'react'
import { ERCText } from 'components/text'
import {colors } from '@mui/material'

const FilterComponent = ({ name, onChange = () => null, defaultValue, data = [], render = () => null, containerClass }) => {

    const [selected, setSelected] = useState({ name, value: defaultValue })

    const selectItem = (e) => {
        console.log(e)
        setSelected({ name, value: e?.value === selected?.value ? null : e?.value })
    }

    useEffect(() => {
        onChange(selected)
    }, [selected, defaultValue])

    return (
        // <div className={styles.body}>

        <div className="flex gap-6 items-center overflow-auto">
            {
                data?.length ?
                    data.map((item) =>
                        <div onClick={() => selectItem({ name, value: item?.value })} >
                            {render(item)}
                        </div>
                    ) : <ERCText size='14px' weight='600' color={colors.red[400]}>Empty</ERCText>
            }

        </div>
        // </div>
    )
}

export default FilterComponent